import React from "react";

function Language(props){
    return <>
        <div className="section p-4 myBlock">
            <h2>Languages</h2>
            <p><b>Hindi : </b> Professional &nbsp;
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
            </p>
            <p><b>English : </b> Professional &nbsp;
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star" style={{color:"#e31b6d"}}></i>
                <i class="fa-solid fa-star-half-stroke" style={{color:"#e31b6d"}}></i>
            </p>
        </div>
    </>
}

export default Language